import React, {useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom";
import './MarketMenuItemDetailed.css';
import ClipLoader from "react-spinners/ClipLoader";
import LoadingPage from '../pages/LoadingPage';
import {Zoom} from 'react-awesome-reveal';
import AllergenDisclaimer from '../../policies/allergen_disclaimer.pdf';
import DropdownContentComponent from '../dropdowns/DropdownContentComponent';
import ServingsDropdown from "../market_menu/ServingsDropdown";
import StockLimitModal from '../StockLimitModal';
// Show "X available" when stock <= this (default 10). Set REACT_APP_STOCK_LOW_THRESHOLD to override.
const STOCK_LOW_THRESHOLD = parseInt(process.env.REACT_APP_STOCK_LOW_THRESHOLD, 10) || 10;

const MarketMenuItemDetailed = ({item, onAddToBasket, currentCatHandle, basket, getCartQuantityForVariant}) => {
    const [itemQuantity, setItemQuantity] = useState(1);
    const [fillAddBsk, setFillAddBsk] = useState(false);
    const [stockLimitModalOpen, setStockLimitModalOpen] = useState(false);
    const [variants, setVariants] = useState([]);
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [mainImageLoaded, setMainImageLoaded] = useState(false);

    useEffect(() => {
      if (item) {
        if (item.variants && item.variants.edges.length > 0) {
          const allVariants = item.variants.edges.map(edge => ({
            price: parseFloat(edge.node.price.amount),
            servings: edge.node.selectedOptions[0].value,
            id: edge.node.id,
            availableForSale: edge.node.availableForSale ?? true,
            quantityAvailable: edge.node.quantityAvailable != null ? edge.node.quantityAvailable : null
          }));
          setVariants(allVariants);
          setSelectedVariant(allVariants[0]);
        }
        setSelectedImageIndex(0);
        setMainImageLoaded(false);
      }
    }, [item]);

    useEffect(() => {
      setMainImageLoaded(false);
    }, [selectedImageIndex]);

    const handleVariantChange = (selectedVariantId) => {
      const selected = variants.find(variant => variant.id === selectedVariantId);
      setSelectedVariant(selected);
    };

    const getStockQuantity = () =>
      selectedVariant?.quantityAvailable != null ? selectedVariant.quantityAvailable : null;
    const stockQty = getStockQuantity();

    function increment() {
      setItemQuantity((prev) => prev + 1);
    }

    function decrement() {
      setItemQuantity((prev) => (prev > 1 ? prev - 1 : 1));
    }

    const ingredients = item.metafields?.find(field => field?.key === "ingredients")?.value;
    const allergens = ['Eggs', 'Cereals Containing Gluten', 'Celery', 'Fish', 'Milk', 'Mustard', 'Nuts', 'Peanuts', 'Sesame Seeds', 'Soya', 'Lupin', 'Crustaceans', 'Molluscs', 'Sulphites'];
    const words = ingredients ? ingredients.split(/\s*,\s*/) : [];

    const isOutOfStock = selectedVariant?.availableForSale === false || (stockQty !== null && stockQty <= 0);
    const stockLabel = stockQty !== null && stockQty <= 0 ? 'Out of stock' : !selectedVariant?.availableForSale ? 'Out of stock' : (stockQty !== null && stockQty <= STOCK_LOW_THRESHOLD ? `${stockQty} available` : 'In stock');

    const formattedIngredients = words.length > 0 ? words.map((word, index) => {
      const matches = word.match(/\(([^)]+)\)/); // Extracts text within parentheses
      if (matches) {
        const allergenText = matches[1];
        if (allergens.includes(allergenText)) {
          return (
            <span key={index}>
              {word.replace(`(${allergenText})`, '')}
              <strong>{`(${allergenText})`}</strong>
              {index !== words.length - 1 ? ", " : ""}
            </span>
          );
        }
      } else if (allergens.includes(word)) {
        return (
          <span key={index}>
            <strong>{word}</strong>
            {index !== words.length - 1 ? ", " : ""}
          </span>
        );
      }
      return (
        <span key={index}>
          {word}
          {index !== words.length - 1 ? ", " : ""}
        </span>
      );
    }) : null;


    const override = {
      display: "flex",
      borderWidth: '5px',
      height: '50px',
      width: '50px',
      position:'absolute',
      left:'calc(50% - 25px)',
      top: 'calc(50% - 25px)',
      zIndex:'0'
    };

    const overrideSmall = {
      display: "flex",
      borderWidth: '3px',
      height: '22px',
      width: '22px',
      position:'absolute',
      left:'calc(50% - 11px)',
      top: 'calc(50% - 11px)',
      bottom:'45px',
      zIndex:'0'
    };

    let navigate = useNavigate();

    const imageUrls = item?.images?.edges?.map(edge => edge.node.src) || [];
    const mainImageUrl = imageUrls.length > 0 ? imageUrls[0] : "../../images/category_default.png";
    const currentImageUrl = imageUrls.length > 0 ? imageUrls[selectedImageIndex] : mainImageUrl;
    const hasMultipleImages = imageUrls.length > 1;

    const goToPrevImage = () => setSelectedImageIndex(prev => (prev === 0 ? imageUrls.length - 1 : prev - 1));
    const goToNextImage = () => setSelectedImageIndex(prev => (prev === imageUrls.length - 1 ? 0 : prev + 1));

  return (
    <>
    {!item ? 
    <LoadingPage height="600px"/> 
    :
    <div className='item_detailed_page_wrapper'>
      
      <div className='item_detailed_option_container'>
      <Zoom triggerOnce={true}>
          <button className='cat_return_btn' onClick={() => { navigate(-1); }}>&#8678; BACK</button>
      </Zoom>
      </div>
      
      <Zoom triggerOnce={true} className='zoom_detail_wrapper'>
      <div className='detailed_wrapper'>
        <div className='detailed_container'>
        <div className='img_detailed_wrapper'>
          <div className='img_carousel_main'>
            <img
              className='menu_item_img_detailed'
              src={currentImageUrl}
              alt={item.title.toUpperCase()}
              loading="eager"
              onLoad={() => setMainImageLoaded(true)}
              onError={() => setMainImageLoaded(true)}
            />
            {hasMultipleImages && (
              <>
                <button type="button" className='carousel_arrow carousel_arrow_left' onClick={goToPrevImage} aria-label="Previous image">
                  <i className="fas fa-chevron-left" aria-hidden="true" />
                </button>
                <button type="button" className='carousel_arrow carousel_arrow_right' onClick={goToNextImage} aria-label="Next image">
                  <i className="fas fa-chevron-right" aria-hidden="true" />
                </button>
              </>
            )}
          </div>
          {hasMultipleImages && (
            <div className='carousel_thumbnails'>
              {imageUrls.map((url, index) => (
                <button
                  key={index}
                  type="button"
                  className={`carousel_thumb${selectedImageIndex === index ? ' carousel_thumb_active' : ''}`}
                  onClick={() => setSelectedImageIndex(index)}
                  aria-label={`View image ${index + 1}`}
                >
                  <img src={url} alt={`${item.title} - view ${index + 1}`} />
                </button>
              ))}
            </div>
          )}
          <ClipLoader
            color={'#001e00'}
            loading={!mainImageLoaded}
            cssOverride={override}
            size={150}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
        <div className='detailed_info_wrapper'>
          <div className='detailed_container_info'>
              <h2>{item.title.toUpperCase()}</h2>
              <span className='price'>£{selectedVariant?.price?.toFixed(2) || "-"}</span>
              <div className='icon_txt_container' style={{margin: "5px 0 10px 0"}}>
                  {variants.length !== 0 && (
                      <>
                          <i className='fas fa-users menu_item_icon_fa menu_item_icon_fa_outline menu_item_icon_fa_detail' style={{margin: "2px 0 0 0"}} aria-hidden='true' />
                          {variants.length === 1 ?
                              <span className='menu_item_notice'>{selectedVariant.servings} servings</span>
                              :
                              <ServingsDropdown variants={variants} selectedVariant={selectedVariant} handleVariantChange={handleVariantChange}/>
                          }
                      </>
                  )}
              </div>
              <div className='icon_txt_container' style={{margin: "5px 0 30px 0"}}>
                <i className={`fas fa-box menu_item_icon_fa menu_item_icon_fa_detail menu_item_icon_fa_outline${isOutOfStock ? ' menu_item_icon_fa_out_of_stock' : ''}`} aria-hidden='true' />
                <span className={`general_info${isOutOfStock ? ' general_info_out_of_stock' : ''}`}>
                  {stockLabel}
                </span>
              </div>
              <div className='tags_container'>
                {item.tags.includes("Ready to eat") && <h4 className='tag ready_to_eat'>Ready to eat</h4>}
                {item.tags.includes("Requires re-heating") && <h4 className='tag requires_reheating'>Requires re-heating</h4>}
                {item.tags.includes("Eat same day") && <h4 className='tag eat_same'>Eat same day</h4>}
                {item.tags.includes("Gluten-free") && <h4 className='tag gluten'>Gluten-free</h4>}
                {item.tags.includes("Vegan") && <h4 className='tag vegan'>Vegan</h4>}
                {item.tags.includes("Vegetarian") && <h4 className='tag vege'>Vegetarian</h4>}
                {item.tags.includes("Freezable") && <h4 className='tag freezeable'>Freezable</h4>}
                {item.tags.includes("Frozen") && <h4 className='tag frozen'>Frozen</h4>}
                {item.tags.includes("Requires cooking") && <h4 className='tag requires_cooking'>Requires cooking</h4>}
              </div>
               <div className='divider'></div>
                <p>{item.description}</p>
               <div className='divider'></div>

          </div>
          {!isOutOfStock && (
          <div className='quantity_container'>
                  <button type="button" className={itemQuantity === 1 ? 'increment_btn inactive' : 'increment_btn'} onClick={decrement}>-</button>
                  <span className='quantity'>{itemQuantity}</span>
                  <button type="button" className='increment_btn' onClick={increment}>+</button>
                  <button type="button" className={fillAddBsk ? 'add_to_basket_btn inactive_add' : 'add_to_basket_btn'}
                  onClick={async () => {
                    if (!selectedVariant) return;
                    setFillAddBsk(true);
                    try {
                      const result = await onAddToBasket(itemQuantity, selectedVariant.id, { quantityAvailable: stockQty });
                      if (!result?.success || result?.showStockLimitModal) setStockLimitModalOpen(true);
                    } catch {
                      setStockLimitModalOpen(true);
                    } finally {
                      setFillAddBsk(false);
                    }
                  }}
                  ><ClipLoader
                  color={'#fff'}
                  loading={fillAddBsk}
                  cssOverride={overrideSmall}
                  size={'50px'}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                  />ADD TO BASKET</button>
          </div>
          )}
        <div className={'item_info_container'}>
          <DropdownContentComponent btnTxt={'INGREDIENTS'} dropdownContent={
            <>
            <span className='item_info'>{formattedIngredients ?? 'No ingredients listed.'}</span>
            <span className='allergy_advice'>
              <b>ALLERGY ADVICE:</b> For allergens see ingredients in bold. We cannot guarantee suitability for people with severe allergies - see our{' '}
              <a href={AllergenDisclaimer} rel="noreferrer" target="_blank" style={{ color: 'blue', textDecoration: 'underline' }}>Allergen Disclaimer</a>
              {' '}for more info.
            </span>  
            </>
          }/>

          <DropdownContentComponent btnTxt={'COOKING INSTRUCTIONS'} dropdownContent={
            <>
            <span className='item_info'>
             {item.metafields?.find(field => field?.key === "cooking_instructions")?.value ?? 'Not provided.'}
            </span> 
            </>
          }/>

          <DropdownContentComponent btnTxt={'STORAGE'} dropdownContent={
            <>
            <span className='item_info'>
            {item.metafields?.find(field => field?.key === "storage")?.value ?? 'Not provided.'}
            </span> 
            </>
          }/>
        </div>

        </div>
        
      </div>
      
      </div>
      </Zoom>
      {/* <div className='disclaimer_container'>
        <h3 className='disclaimer_title'>DISCLAIMER:</h3>
        <span className='disclaimer'>Please note that items prepared in our kitchen may have been manufactured, processed, or stored in facilities that handle allergens. Despite our best efforts to prevent cross-contamination, there is a possibility that allergens could be present in any food item due to the shared equipment or storage areas. We take food safety seriously and strive to provide accurate ingredient information. However, we cannot guarantee that our items are entirely free from allergenic substances. We strongly recommend that individuals with severe allergies or sensitivities exercise caution and take necessary precautions when consuming our food products. If you require specific advice on any Chatters Chatterbox item, please don't hesitate to get in contact.</span>
      </div> */}
      </div>
    }
      <StockLimitModal
        isOpen={stockLimitModalOpen}
        onClose={() => setStockLimitModalOpen(false)}
      />
    </>
  )
}

export default MarketMenuItemDetailed
